import { escolas_sem_turmas_criadas } from "./escolas-sem-turmas-criadas";
import { escolas_com_turmas_sem_estrutura_curricular } from "./escolas-com-turmas-sem-estrutura-curricular";
import { resumo_de_salas_versus_turmas } from "./resumo-de-salas-versus-turmas";

const relatorio_de_apoio_gerencial_da_turma = [
  escolas_sem_turmas_criadas,
  escolas_com_turmas_sem_estrutura_curricular,
  resumo_de_salas_versus_turmas,
];

export { relatorio_de_apoio_gerencial_da_turma };
